import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize.css'
import './style/main.less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

var axios = require('axios');
axios.defaults.baseURL = 'http://www.shengjia-resin.com:81/app'
// axios.defaults.baseURL = 'http://192.168.1.118:9999/app'

Vue.prototype.$axios = axios

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
        document.keyword = to.meta.keyword
        document.description = to.meta.description
        document.viewport = to.meta.viewport
    }
    next()
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')